/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Dataset_ColourInputs */

const en_reference_dataset_colour = /** @type {(inputs: Reference_Dataset_ColourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colours`)
};

/**
* | output |
* | --- |
* | "Colours" |
*
* @param {Reference_Dataset_ColourInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_dataset_colour = /** @type {((inputs?: Reference_Dataset_ColourInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Dataset_ColourInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_dataset_colour(inputs)
});